import { render } from "./ImageLTextR.vue?vue&type=template&id=0496dbda"
import script from "./ImageLTextR.vue?vue&type=script&lang=js"
export * from "./ImageLTextR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__